import 'bootstrap/js/dist/tooltip'

export default {
  init() {
    $('[data-toggle="tooltip"]').tooltip()
  },
}
